import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { GET_DASHBOARD_CANCELLED_TASKS } from './actionTypes';
import { getDashboardCancelledTasksSuccess, getDashboardCancelledTasksError } from './actions';
import { taskStatusBack } from '../../../constants/task_fields';

// Include call API
import { getTasksAPI } from '../../../api/tasks';

const tasksAPI = getTasksAPI();

const CANCELLED_STATUS = `${taskStatusBack.CANCELADA}`;

function* getDashboardCancelledTasks({ payload: { user, size, page } }) {
  try {
    const response = yield call(tasksAPI.getTasks, user.token, size, page, CANCELLED_STATUS);
    yield put(getDashboardCancelledTasksSuccess(response.paginator, response.message));
  } catch (error) {
    yield put(getDashboardCancelledTasksError(error));
  }
}

export function* watchGetDashboardCancelledTasks() {
  yield takeEvery(GET_DASHBOARD_CANCELLED_TASKS, getDashboardCancelledTasks);
}

function* getDashboardCancelledTasksSaga() {
  yield all([fork(watchGetDashboardCancelledTasks)]);
}

export default getDashboardCancelledTasksSaga;
